// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBorderInnerOutlinedSvg from "@fishx/icons-svg/es/asn/PBorderInnerOutlined";
import FishxIcon from '../components/FishxIcon';

var PBorderInnerOutlined = function PBorderInnerOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBorderInnerOutlinedSvg
  }));
};

PBorderInnerOutlined.displayName = 'PBorderInnerOutlined';
export default React.forwardRef(PBorderInnerOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBorderInnerOutlined.js
// module id = 3245
// module chunks = 0